<svg *ngIf="icon" [ngClass]="getClass()" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" [attr.fill]="fillInput" [attr.viewBox]="'0 0 24 24'">
  <path [attr.d]="icon()" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" [attr.stroke-width]="stroke"/>
</svg>
